
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { CoreModule } from './core/core.module';
import { LanguageModule } from './core/language/language.module';
import { GlobalEventsManagerService } from './core/services/global-events-manager.service';
import { AuthHttpInterceptorService } from './core/services/auth-http-interceptor.service';
import { SecurityService } from './core/services/security.service';
import { DatePipe } from '@angular/common';

@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent       
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        FormsModule,
        CoreModule,
        LanguageModule,
        RouterModule.forRoot([
            { path: '', pathMatch: 'full', redirectTo: 'home' },
            { path: 'home', loadChildren: 'app/home/home.module#HomeModule' },
            { path: 'complaints', loadChildren: 'app/complaints/complaints.module#ComplaintsModule' },
            { path: 'info-section', loadChildren: 'app/info-section/info-section.module#InfoSectionModule' },
            { path: 'admin', loadChildren: 'app/admin/admin.module#AdminModule' },
            { path: 'login', loadChildren: 'app/login/login.module#LoginModule' },
            { path: 'register', loadChildren: 'app/register/register.module#RegisterModule' },
            { path: 'user-basic-data', loadChildren: 'app/user-basic-data/user-basic-data.module#UserBasicDataModule' },
            { path: 'reports', loadChildren: 'app/reports/reports.module#ReportsModule' },
            { path: 'public-sessions', loadChildren: 'app/sessions/sessions.module#SessionsModule' },
            { path: 'questions', loadChildren: 'app/questions/questions.module#QuestionsModule' },
            { path: 'offline-debates', loadChildren: 'app/debates/offline-debates/offline-debates.module#OfflineDebatesModule' },
            { path: 'online-debates', loadChildren: 'app/debates/online-debates/online-debates.module#OnlineDebatesModule' },
            { path: 'debate', loadChildren: 'app/debates/statistics/statistics.module#StatisticsModule' },
            { path: 'help-contacts', loadChildren: 'app/help-contacts/help-contacts.module#HelpContactsModule' },
            { path: 'privacy-policy', loadChildren: 'app/privacy-policy/privacy-policy.module#PrivacyPolicyModule' },
            { path: 'terms-and-requirements', loadChildren: 'app/terms-and-requirements/terms-and-requirements.module#TermsAndRequirementsModule' },
            { path: 'survey', loadChildren: 'app/survey/surveys.module#SurveysModule' },
           // { path: 'public-survey-list', loadChildren: 'app/surveys/survey.module#SurveyModule' },
            { path: 'eServices', loadChildren: 'app/administrative-procedures/e-services/e-services.module#EServicesModule' },
        ], {
            scrollPositionRestoration: 'top'  // postavi scroll na vrh kod svake navigacije
        })
    ],
    exports: [],
    providers: [/*{ provide: LOCALE_ID, useValue: 'bs-Latn-BA' },*/
        GlobalEventsManagerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptorService,
            multi: true
        },
        SecurityService,
        DatePipe
    ],
    bootstrap: [AppComponent]
})
  
export class AppModule { }

